module.exports = __webpack_public_path__ + "img/228.4a080831.png";